import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';
var CurrentVariantStateContext = createContext({
  setVariant: function setVariant() {},
  setVariantList: function setVariantList() {
    return [];
  },
  setInitialSku: function setInitialSku() {},
  currentVariant: {
    variantId: '',
    barcodeNumber: '',
    title: '',
    variantSku: '',
    imageIndex: ''
  }
});
var useCurrentVariantStateContext = function useCurrentVariantStateContext() {
  return useContext(CurrentVariantStateContext);
};
var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};
var getLocationPath = function getLocationPath() {
  return isBrowser() ? window.location.pathname : null;
};
var getLocationQueryStringParam = function getLocationQueryStringParam(param) {
  var strategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'array';
  if (!isBrowser()) {
    return strategy === 'string' ? '' : [];
  }
  var qs = new URLSearchParams(window.location.search);
  var stringValue = decodeURIComponent(qs.get(param) || '');
  if (strategy === 'string') {
    return stringValue;
  }
  try {
    return JSON.parse("[".concat(stringValue, "]"));
  } catch (e) {
    console.error(e);
    return [];
  }
};
var generateLocationQueryString = function generateLocationQueryString(param, value) {
  if (!isBrowser()) {
    return '';
  }
  var qs = new URLSearchParams(window.location.search);
  qs.set(param, value);
  return "".concat(getLocationPath(), "?").concat(qs.toString());
};
var CurrentVariantStateProvider = function CurrentVariantStateProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    variantId = _useState2[0],
    setVariantId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    initialSku = _useState4[0],
    setInitialSku = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    variantList = _useState6[0],
    setVariantList = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    currentVariant = _useState8[0],
    setCurrentVariant = _useState8[1];
  var setVariant = function setVariant(id) {
    setVariantId(id);
    var url = generateLocationQueryString('variantId', id);
    window.history.pushState(null, '', url);
  };
  var idFromQuery = getLocationQueryStringParam('variantId', 'string');
  useEffect(function () {
    var initialVariant = variantList.find(function (v) {
      return v.variantSku === initialSku;
    });
    if (!idFromQuery && initialVariant) {
      setVariant(initialVariant.variantId);
    }
  }, [initialSku]);
  useEffect(function () {
    if (idFromQuery) {
      setVariantId(idFromQuery);
    }
  }, [idFromQuery]);
  useEffect(function () {
    var searchedVariant = variantList.find(function (v) {
      return v.variantId === variantId;
    });
    if (searchedVariant) {
      setCurrentVariant(searchedVariant);
    }
  }, [variantId, variantList]);
  var currentVariantState = useMemo(function () {
    return {
      currentVariant: currentVariant,
      setInitialSku: setInitialSku,
      setVariant: setVariant,
      setVariantList: setVariantList
    };
  }, [currentVariant]);
  return jsx(CurrentVariantStateContext.Provider, Object.assign({
    value: currentVariantState
  }, {
    children: children
  }));
};
export { CurrentVariantStateContext, CurrentVariantStateProvider, useCurrentVariantStateContext };